import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { ownerAPI } from '../utils/api';
import './QRCodePanel.css';

const QRCodePanel = ({ qrCode: initialQR, doorUrl, doorId }) => {
  const [qrCode, setQrCode] = useState(initialQR);
  const [loading, setLoading] = useState(false);

  const handleRegenerate = async () => {
    setLoading(true);
    try {
      const res = await ownerAPI.getQRCode();
      setQrCode(res.data.data.qrCode);
      toast.success('QR code refreshed');
    } catch {
      toast.error('Failed to regenerate QR code');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = () => {
    if (!qrCode) return;
    const link = document.createElement('a');
    link.href = qrCode;
    link.download = `qr-doorbell-${doorId?.substring(0, 8)}.png`;
    link.click();
    toast.success('QR code downloaded!');
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(doorUrl || '');
      toast.success('Door link copied!');
    } catch {
      toast.error('Failed to copy link');
    }
  };

  return (
    <div className="qr-root animate-fade-in">
      <div className="qr-card">
        {/* QR display */}
        <div className="qr-display">
          {qrCode ? (
            <img src={qrCode} alt="Your door QR code" className="qr-image" />
          ) : (
            <div className="qr-placeholder">
              <div className="spinner" style={{ width: 40, height: 40 }} />
            </div>
          )}
        </div>

        {/* Instructions */}
        <div className="qr-info">
          <h3 className="qr-info-title">Your Smart Doorbell QR Code</h3>
          <p className="qr-info-desc">
            Print this QR code and place it at your door. Visitors scan it to ring your bell —
            without ever seeing your phone number.
          </p>

          {doorUrl && (
            <div className="qr-url-box">
              <span className="qr-url-text">{doorUrl}</span>
              <button className="btn btn-ghost btn-sm qr-copy-btn" onClick={handleCopyLink}>
                Copy
              </button>
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="qr-actions">
          <button
            className="btn btn-primary btn-lg"
            onClick={handleDownload}
            disabled={!qrCode}
          >
            ⬇ Download QR Code
          </button>
          <button
            className="btn btn-secondary"
            onClick={handleRegenerate}
            disabled={loading}
          >
            {loading ? <><div className="spinner" /> Generating…</> : '↻ Regenerate'}
          </button>
        </div>
      </div>

      {/* Print tips */}
      <div className="qr-tips">
        <h4 className="qr-tips-title">Placement Tips</h4>
        <ul className="qr-tips-list">
          <li>🖨️ Print at minimum <strong>8×8cm</strong> for easy scanning</li>
          <li>☀️ Avoid direct sunlight glare on the code</li>
          <li>💧 Use a weatherproof sleeve or laminate for outdoor use</li>
          <li>📍 Place at eye level, near your existing doorbell</li>
          <li>🔒 The QR code doesn't expire unless you regenerate it</li>
        </ul>
      </div>
    </div>
  );
};

export default QRCodePanel;
